export function noValue (text: string|number|null|undefined, emptyText="(No Value)"): string {
  if (typeof text == 'number') return text.toString()
  return text == null || text == undefined || text.trim() == '' ? emptyText : text

}
